import ClientFactory from "@/api/ClientFactory";
const AuthApi = ClientFactory.get("auth");
import router from "@/router";

// *From Auth - Data will be received from auth provider
const userDefaults = {
  username: "admin"
};

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {};
const getUserInfo = () => {
  const userInfo = {};
  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key]
      ? userInfoLocalStorage[key]
      : userDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null)
      userInfo[key] = userInfoLocalStorage[key];
  });
  return userInfo;
};

const state = {
  token: "",
  AppActiveUser: getUserInfo(),
  isUserLoggedIn: () => {
    let isAuthenticated = false;

    // Check accessToken
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      isAuthenticated = true;
    }

    return isAuthenticated;
  },
};

const actions = {
  async login({ commit }, payload) {
    const response = await AuthApi.login(payload);
    console.log(response);
    if (response.data.token) {
      // Set accessToken
      localStorage.setItem("accessToken", response.data.token);
      // Update user details
      commit("UPDATE_USER_INFO", response.data);
      // Navigate User to homepage

      router.push(router.currentRoute.query.to || "/dashboard");
    } else {
      throw "Sai Tên người dùng hoặc Mật khẩu";
    }
  },

  async logout() {
    // Clean storage
    if (localStorage.getItem("accessToken")) {
      localStorage.removeItem("accessToken");
    }
    localStorage.removeItem("userInfo");
    localStorage.removeItem("rus");

    // Redirect to login page
    setTimeout(() => {
      router.push(router.currentRoute.query.to || "/pages/login");
    }, 600);
  },
};

const mutations = {
  UPDATE_USER_INFO(state, response) {
    const { token, data } = response;

    // Get Data localStorage
    const userInfo =
      JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser;

    for (const property of Object.keys(data)) {
      if (data[property] !== null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = data[property];

        // Update key in localStorage
        userInfo[property] = data[property];
      }
    }

    state.token = token;
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
